import { post } from 'lib/api';

import { useMutation, useQueryClient } from '@tanstack/react-query';

const postLogin = async (fields) => {
  const data = await post('auth/login', {
    username: fields.username,
    password: fields.password
  });

  return data;
};

export function useUserLogin() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postLogin,
    onSuccess: () => {
      queryClient.setQueryData(['login', 'after'], { postLogin: true });
      queryClient.setQueryDefaults(['login', 'after'], {
        gcTime: Infinity,
        staleTime: Infinity
      });

      queryClient.invalidateQueries('currentUser');
    }
  });
}
